export default {
  office: {
    placeholder: '机构名称/机构编码',
    officeNo: '机构编码',
    officeType: '机构别',
    grade: '层级',
    sort: '排序',
    typeOptions: ['公司', '部门'],
    officeTypeOptions: ['采购商', '供应商', '采购商和供应商'],
    type: '机构类型',
    isDeliver: '供应商发货限制',
    parentId: '上级机构',
    name: '机构名称',
    creditCode: '统一社会信用代码',
    master: '负责人',
    phone: '电话',
    fax: '传真',
    regionId: '机构地址',
    addressDetail: '详细地址',
    zipCode: '邮政编码',
    dialogTitle: '上级机构选择',
    isShow: '是否显示金额栏位'
  },
  sysmenu: {
    menuType: '平台',
    menuLevel: '等级',
    name: '菜单名称',
    menuMark: '功能标识',
    icon: '图标',
    sort: '排序',
    isShow: '状态',
    menuMark1: '模块',
    menuMark2: '菜单',
    menuMark3: '功能',
    isShowY: '显示',
    isShowN: '隐藏',
    vueUrl: '路由名称',
    add: '新增同级菜单',
    addChild: '新增子菜单'
  },
  factory: {
    searchPlaceholder: '工厂编号/工厂名称',
    purchaseUnitId: '采购中心',
    factoryNo: '工厂编码',
    factoryName: '工厂名称',
    purchaseUnitName: '采购中心',
    completeAddress: '工厂地址',
    description: '描述',
    statusMessage: ['', '是否停用?', '是否启用?'],
    usingFlagOptions: ['启用', '停用'],
    areaId: '工厂地址',
    detailAddress: '详细地址',
    usingFlag: '启用状态',
    officeNo: '所属机构'
  },
  purchaseUnit: {
    searchPlaceholder: '采购中心编码/名称',
    usingFlagOptions: ['启用', '停用'],
    statusMessage: ['', '是否停用?', '是否启用?'],
    purchaseUnitNo: '采购中心编码',
    purchaseUnitName: '采购中心名称',
    db: '数据库',
    description: '描述',
    officeId: '结算机构',
    usingFlag: '启用状态',
    purchaseName: '结算机构',
    factoryEnableSign: '是否启用工厂',
    tableTitle: '工厂明细',
    factoryNo: '工厂',
    officeNo: '结算机构',
    enableSign: '状态',
    requireList: '请添加工厂明细'
  },
  DBSetting: {
    usingFlagOptions: ['启用', '停用'],
    searchPlaceholder: '请输入DBName查询',
    outDbType: '外部系统品牌',
    dbName: 'DBName(ent)',
    dbNamed: 'DBName(ent)名称',
    srmSettingType: '对应srm设置类别',
    srmSettingNo: '对应srm设置编码',
    srmSettingName: '对应srm设置名称',
    statusMessage: {
      Y: '是否停用?',
      N: '是否启用?'
    },
    usingFlag: '启用状态'
  },
  sysrole: {
    placeholder: '请输入角色编号或角色名称查询',
    roleNo: '角色编号',
    name: '角色名称',
    roleDes: '角色描述',
    adddate: '创建时间',
    upddate: '更新时间',
    officeId: '所属机构',
    authority: '功能权限',
    isDeleteProcess: '是否可以删除绩效单'
  },
  sysuser: {
    searchPlaceholder: '请输入用户名或姓名进行查询',
    name: '姓名',
    officeName: '所属机构',
    officeId: '所属机构',
    deptName: '所属部门',
    deptId: '所属部门',
    no: '工号',
    mobile: '手机',
    loginName: '登录名',
    email: '邮箱',
    showPower: '数据权限',
    sex: '性别',
    age: '年龄',
    userId: '身份证',
    positionStatus: '任职状态',
    entryDate: '入职日期',
    password: '密码',
    surePassword: '确认密码',
    workInfo: '工作资料',
    loginInfo: '登录设置',
    roleInfo: '角色权限',
    viewPermissions: '查看权限',
    objectType: '对象类型编码',
    objectTypeName: '对象类型名称',
    objectNo: '对象编码',
    objectName: '对象名称',
    tableOperation: '操作',
    remove: '删除',
    ifDelete: '是否删除该数据权限？',
    clearAll: '清空数据权限',
    ifClearALl: '是否清空数据权限？',
    import: '导入',
    importData: '导入数据',
    importTemplate: '导入模板',
    downloadTemplate: '下载模板',
    importTip: '仅允许上传"xls"或"xlsx"格式文件'
  },
  data: {
    searchPlaceholder: '请输入权限分组编码查询',
    powerGroupName: '权限分组名称',
    remarks: '备注',
    powerGroupNo: '权限分组编码',
    powerList: '数据权限',
    addPowerList: '添加权限',
    objectType: '对象类型名称',
    objectName: '对象名称',
    userName: '用户',
    objectTypeName: '对象类型名称',
    addPowerTitle: '添加数据权限',
    classifyNo: '供应商分类',
    office: '部门',
    leftTitle: '对象权限',
    rightTitle: '人员权限',
    sumMessage: '请选择对应的对象'
  }
}
